/**
 * STEMO: Keep theme "Add to cart" independent from Pareto QB tier selection.
 * - Theme ATC uses the theme quantity selector (default 1).
 * - Pareto QB tiers show volume pricing; Pareto's own ATC keeps Pareto quantity.
 *
 * Load in <head> before Pareto so this fetch/XHR patch sits inside Pareto's wrapper
 * and can restore theme quantity after Pareto overrides it.
 */
(function () {
  const PARETO_ROOT_SELECTOR = '[id*="p_quantity_breaks"], .omg-groupsTable';
  let lastAddSource = "theme";

  function getParetoRoot() {
    return document.querySelector(PARETO_ROOT_SELECTOR);
  }

  function getProductForm() {
    return document.querySelector('form[is="product-form"]');
  }

  function getThemeQuantity() {
    const form = getProductForm();
    const formId = form?.getAttribute("id");
    let qtyInput = formId ? document.getElementById(`${formId}-quantity`) : null;
    if (!qtyInput) {
      qtyInput = document.querySelector('.product-info__quantity-selector input[name="quantity"]');
    }
    if (!qtyInput && form) {
      qtyInput = form.querySelector('input[name="quantity"]');
    }
    const qty = parseInt(qtyInput?.value ?? "1", 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function isParetoAddToCartClick(target) {
    const root = getParetoRoot();
    if (!root || !root.contains(target)) return false;
    return Boolean(
      target.closest(
        'button, [role="button"], input[type="submit"], a[href*="/cart/add"], .ot-add-to-cart, [class*="add-to-cart" i], [class*="addtocart" i]'
      )
    );
  }

  function isThemeAddToCartClick(target) {
    return Boolean(
      target.closest(
        'buy-buttons button[type="submit"], form[is="product-form"] button[type="submit"], .buy-buttons button'
      )
    );
  }

  function trackAddSource(event) {
    if (isParetoAddToCartClick(event.target)) {
      lastAddSource = "pareto";
      return;
    }
    if (isThemeAddToCartClick(event.target)) {
      lastAddSource = "theme";
    }
  }

  function applyThemeQuantityToFormData(formData) {
    formData.set("quantity", String(getThemeQuantity()));
  }

  function patchCartAddFetch() {
    if (window.__stemoParetoFetchPatched) return;
    window.__stemoParetoFetchPatched = true;

    const originalFetch = window.fetch.bind(window);
    window.fetch = function (url, options) {
      const urlString = typeof url === "string" ? url : url?.url || "";
      if (
        urlString.includes("/cart/add") &&
        options?.body instanceof FormData &&
        lastAddSource === "theme" &&
        getParetoRoot()
      ) {
        applyThemeQuantityToFormData(options.body);
      }
      return originalFetch(url, options);
    };
  }

  function patchCartAddXHR() {
    if (window.__stemoParetoXHRPatched) return;
    window.__stemoParetoXHRPatched = true;

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__stemoMethod = method;
      this.__stemoUrl = url;
      return originalOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (body) {
      if (
        this.__stemoMethod === "POST" &&
        String(this.__stemoUrl || "").includes("/cart/add") &&
        body instanceof FormData &&
        lastAddSource === "theme" &&
        getParetoRoot()
      ) {
        applyThemeQuantityToFormData(body);
      }
      return originalSend.call(this, body);
    };
  }

  function bindProductForm() {
    const form = getProductForm();
    if (!form || form.__stemoParetoBound) return;
    form.__stemoParetoBound = true;

    form.addEventListener(
      "submit",
      () => {
        lastAddSource = "theme";
      },
      true
    );
  }

  function init() {
    document.addEventListener("click", trackAddSource, true);
    bindProductForm();

    if (!getParetoRoot()) {
      const observer = new MutationObserver(() => {
        bindProductForm();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  patchCartAddFetch();
  patchCartAddXHR();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
